const table = [];
const poly = 0xEDB88320; // reverse polynomial

// build the table
function makeTable() {
	let c; let n; let
		k;

	for (n = 0; n < 256; n += 1) {
		c = n;
		for (k = 0; k < 8; k += 1) {
			if (c & 1) {
				c = poly ^ (c >>> 1);
			}
			else {
				c >>>= 1;
			}
		}
		table[n] = c >>> 0;
	}
}

function stringToArray(string) {
	// sweet hack to turn string into a 'byte' array
	return Array.prototype.map.call(string, c => c.charCodeAt(0));
}

/*
   * Compute CRC of array directly.
   *
   * This is slower for repeated calls, so append mode is not supported.
   */
function crcDirect(array) {
	let crc = -1; // initial contents of LFBSR
	let i; let j; let l; let
		temporary;

	for (i = 0, l = array.length; i < l; i += 1) {
		temporary = (crc ^ array[i]) & 0xFF;

		// read 8 bits one at a time
		for (j = 0; j < 8; j += 1) {
			if ((temporary & 1) === 1) {
				temporary = (temporary >>> 1) ^ poly;
			}
			else {
				temporary >>>= 1;
			}
		}
		crc = (crc >>> 8) ^ temporary;
	}

	// flip bits
	return crc ^ -1;
}

/*
   * Compute CRC with the help of a pre-calculated table.
   *
   * This supports append mode, if the second parameter is set.
   */
function crcTable(array, append) {
	let crc; let i; let
		l;

	// if we're in append mode, don't reset crc
	// if arr is null or undefined, reset table and return
	if (typeof crcTable.crc === 'undefined' || !append || !array) {
		crcTable.crc = 0 ^ -1;

		if (!array) {
			return;
		}
	}

	// store in temp variable for minor speed gain
	crc = crcTable.crc;

	for (i = 0, l = array.length; i < l; i += 1) {
		crc = (crc >>> 8) ^ table[(crc ^ array[i]) & 0xFF];
	}

	crcTable.crc = crc;

	return crc ^ -1;
}

// build the table
// this isn't that costly, and most uses will be for table assisted mode
makeTable();

const exports = function (value, direct) {
	var value = (typeof value === 'string') ? stringToArray(value) : value;
	const returnValue = direct ? crcDirect(value) : crcTable(value);

	// convert to 2's complement hex
	return (returnValue >>> 0).toString(16);
};
exports.direct = crcDirect;
exports.table = crcTable;

export default exports;
